import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import HowWorks from '@/components/HowWorks'
import Verify from '@/components/Verify'
import Settings from '@/components/Settings'
import Box from '@/components/Box'
import BoxEdit from '@/components/BoxEdit'
import MyBoxes from '@/components/MyBoxes'
import MyDownloads from '@/components/MyDownloads'
import Users from '@/components/Users'
import User from '@/components/User'
import Admin from '@/components/Admin'
import AdminUser from '@/components/AdminUser'


Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/'
		},
		{
			path: '/ajuda',
			name: 'HowWorks',
			component: HowWorks
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
        {
			path: '/',
			name: 'Dashboard',
			component: Dashboard,
            // meta: {
            //     requiresAuth: true
            // }
		},
        {
			path: '/verify',
			name: 'Verify',
			component: Verify,
            // meta: {
            //     requiresAuth: true
            // }
		},
        {
			path: '/perfil',
			name: 'Settings',
			component: Settings,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/comarca/:id',
			name: 'Comarca',
			component: Dashboard,
            // meta: {
            //     requiresAuth: true
            // }
		},
        {
			path: '/iniciativa/:id',
			name: 'Box',
			component: Box,
            // meta: {
            //     requiresAuth: true
            // }
		},
        {
			path: '/edita/:id',
			name: 'BoxEditId',
			component: BoxEdit,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/les-meves-iniciatives',
			name: 'MyBoxes',
			component: MyBoxes,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/edita',
			name: 'BoxEdit',
			component: BoxEdit,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/users',
			name: 'Users',
			component: Users,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/entitat/:id',
			name: 'User',
			component: User,
            meta: {
                requiresAuth: false
            }
		},	
        {
			path: '/admin',
			name: 'Admin',
			component: Admin,
            meta: {
                requiresAuth: true
            }
		},
        {
			path: '/admin/user/:id',
			name: 'AdminUser',
			component: AdminUser,
            meta: {
                requiresAuth: true
            }
		}
	]
})

router.beforeEach((to, from, next) => {
	console.log('from', from)
	console.log('to', to)
	let fromToComarca = to.fullPath.indexOf('/comarca/') >= 0

	if (!fromToComarca) {
		window.scrollTo(0, 0)
	}	

    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser	
	
	if (requiresAuth && !currentUser) {
        next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js